import React, { useState } from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { exportGeoJSON } from '../../utils/geoUtils';

function ExportPanel({ geoJsonData }) {
  const [filename, setFilename] = useState('export');

  const handleExport = (format) => {
    exportGeoJSON(geoJsonData, format, filename);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Export Data</Typography>
      <TextField
        label="Filename"
        value={filename}
        onChange={(e) => setFilename(e.target.value)}
        size="small"
        fullWidth
        sx={{ mb: 2 }}
      />
      <Stack spacing={1}>
        <Button
          onClick={() => handleExport('geojson')}
          variant="contained"
          startIcon={<DownloadIcon />}
          disabled={geoJsonData.features.length === 0}
        >
          Export .geojson
        </Button>
        <Button
          onClick={() => handleExport('kml')}
          variant="outlined"
          startIcon={<DownloadIcon />}
          disabled={geoJsonData.features.length === 0}
        >
          Export .kml
        </Button>
        <Button
          onClick={() => handleExport('gpx')}
          variant="outlined"
          startIcon={<DownloadIcon />}
          disabled={geoJsonData.features.length === 0}
        >
          Export .gpx
        </Button>
      </Stack>
    </Box>
  );
}

export default ExportPanel;
